import * as Types from '../../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateAlertMutationVariables = Types.Exact<{
  input: Types.CreateAlertInput;
}>;

export type CreateAlertMutation = {
  __typename?: 'Mutation';
  createAlert: {
    __typename?: 'Alert';
    id: any;
    name: string;
    description?: string | null;
    status: Types.AlertStatus;
    triggerCount: number;
    createdAt: any;
    updatedAt: any;
  };
};

export const CreateAlertDocument = gql`
  mutation CreateAlert($input: CreateAlertInput!) {
    createAlert(input: $input) {
      id
      name
      description
      status
      triggerCount
      createdAt
      updatedAt
    }
  }
`;
export type CreateAlertMutationFn = Apollo.MutationFunction<
  CreateAlertMutation,
  CreateAlertMutationVariables
>;

/**
 * __useCreateAlertMutation__
 *
 * To run a mutation, you first call `useCreateAlertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAlertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAlertMutation, { data, loading, error }] = useCreateAlertMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAlertMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateAlertMutation,
    CreateAlertMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateAlertMutation, CreateAlertMutationVariables>(
    CreateAlertDocument,
    options,
  );
}
export type CreateAlertMutationHookResult = ReturnType<
  typeof useCreateAlertMutation
>;
export type CreateAlertMutationResult =
  Apollo.MutationResult<CreateAlertMutation>;
export type CreateAlertMutationOptions = Apollo.BaseMutationOptions<
  CreateAlertMutation,
  CreateAlertMutationVariables
>;
